// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202606151513/js/" + chunkId + "." + {"44":"583683c6","225":"d64a1089","481":"718d504e","486":"19611e94","770":"a55a82b6"}[chunkId] + ".0.28711023630848964.chunk.js";
};